import React, { useEffect, useState } from 'react';
import useLocaleMode from '../../../hooks/useLocaleMode';
import { useStaticQuery, graphql } from 'gatsby';
import ModalRegisterProspect from '../modal-register-prospect/modal-register-prospect';
import { pushDataLayerEvent } from '../../../utils/metricManagementUtil';
import { dataLayerUserInfo } from '../../../utils/userInfo';
import './leaflet-card.scss';
import DynamicImage from '../../atoms/dynamic-image/dynamic-image';

const LeafletCard = ({ leafletContent: propLeafletContent, isMobile }) => {
  const {
    allContentfulTenaRegistroV2: { nodes },
  } = useStaticQuery(graphql`
    {
      allContentfulTenaRegistroV2(
        filter: { titulo: { eq: "Registro > Pauta" } }
      ) {
        nodes {
          node_locale
          titulo
          banner {
            description
            gatsbyImageData(width: 1200, placeholder: BLURRED, layout: CONSTRAINED)
          }
          botonFinalizar
          registroProspectoInscripcionExitosa {
            raw
          }
        }
      }
    }
  `);

  const { locale } = useLocaleMode();
  const filterContent = nodes.find(node => node.node_locale === locale);
  const leafletContent = propLeafletContent || filterContent;
  const [isModalProspect, setIsModalProspect] = useState(false);
  const userInfo = dataLayerUserInfo();

  const dataLaterBanner = () => {
    let loc = '';
    if (typeof window !== 'undefined') {
      loc = window.location.href;
    }
    pushDataLayerEvent({
      event: 'Interacciones - Banners',
      category: 'banner_secundario',
      action: 'click',
      label: 'Inscripción Prospecto',
      banner_name: 'Inscripción Prospecto',
      location: loc,
      user_data: userInfo.user_data ? userInfo.user_data : '',
      log_status: userInfo.log_status,
    });
  };

  useEffect(() => {
    if (localStorage.getItem('dataUserRegisteredProspect')) {
      setIsModalProspect(true);
    }
  }, []);

  return (
    <>
      <div
        className='f-leaflet-card'
        onClick={() => {
          setIsModalProspect(true);
          dataLaterBanner();
        }}
      >
        <DynamicImage
          image={leafletContent.banner[isMobile ? 1 : 0]}
          alt='banner image'
          className='f-leaflet-card__image-full'
        />
      </div>

      {isModalProspect && (
        <ModalRegisterProspect
          buttonProspect={leafletContent.botonFinalizar}
          hideAction={() => setIsModalProspect(false)}
          showMessageSuccess={true}
          modalSuccessInfo={leafletContent.registroProspectoInscripcionExitosa}
        />
      )}
    </>
  );
};

export default LeafletCard;